import React from 'react';
import { WithOptionalPermission, WithOptionalPermissionProps } from '../WithPermission';
import {
  NavDropdown as CommonNavDropdown,
  NavDropdownProps as CommonNavDropdownProps
} from '@td-client-frontend/common';

export type NavDropdownProps = CommonNavDropdownProps & WithOptionalPermissionProps;

export const NavDropdown = ({ requiredPerms, mode, ...navDropdownProps }: NavDropdownProps) => (
  <WithOptionalPermission requiredPerms={requiredPerms} mode={mode}>
    <CommonNavDropdown {...navDropdownProps} />
  </WithOptionalPermission>
);
